import {
  useAnimation,
  transition,
  query,
  style,
  stagger,
  animate,
  trigger,
  AUTO_STYLE,
  state,
} from '@angular/animations';
import { collapse, expand } from '@sg/ui-kit/animations';

export const commonTransitions = {
  collExpand: [
    transition('void => *', useAnimation(expand, { params: { timing: 0.5, timingFn: 'ease-out' } })),
    transition('* => void', useAnimation(collapse, { params: { timing: 0.5, timingFn: 'ease-out' } })),
  ],
  rowFadeOut: [transition('* => true', [animate('0.4s', style({ opacity: 0, height: 0, minHeight: 0 }))])],
  rowFadeIn: [
    transition('* => true', [
      style({ opacity: 0, height: 0, minHeight: 0 }),
      animate('1s', style({ opacity: 1, height: '*', minHeight: '*' })),
    ]),
  ],
  staggerEnterSlideDown: [
    transition('* => true', [
      query(':enter.enter-slide-down, .on-show-slide-down', style({ opacity: 0 }), {
        optional: true,
      }),
      query(
        ':enter.enter-slide-down, .on-show-slide-down',
        stagger(75, [
          style({ transform: 'translateY(-10%)', opacity: 0 }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)', opacity: 1 })),
        ]),
        { optional: true }
      ),
    ]),
  ],
  staggerEnterSlideRight: [
    transition('* => true', [
      query(':enter.enter-slide-right, .on-show-slide-right', style({ opacity: 0 }), {
        optional: true,
      }),
      query(
        ':enter.enter-slide-right, .on-show-slide-right',
        stagger(75, [
          style({ transform: 'translateX(-10%)', opacity: 0 }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)', opacity: 1 })),
        ]),
        { optional: true }
      ),
    ]),
  ],
  bodyExpansion: trigger('bodyExpansion', [
    state('false', style({ height: '0px', visibility: 'hidden', padding: '0 24px' })),
    state('true', style({ height: AUTO_STYLE, visibility: 'visible', padding: AUTO_STYLE })),
    transition('true <=> false', animate('200ms ease-in-out')),
  ]),
};
